import { useCookies } from '@/composables/cookies'
import {
  CJ_COOKIE_NAME,
  CJ_EVENT_MAX_LENGTH,
  CJ_EVENT_QUERY_PARAM,
} from './consts'

type GetCjEventIdOptions = {
  search?: string
}

export { initCjAffiliateAttribution, persistCjEvent, tryPersistCjEvent } from './persist'

type UseCjAffiliateResult = {
  getCjEventId: (options?: GetCjEventIdOptions) => string | null
  getCjEventIdFromSearch: (search: string) => string | null
}

export function normalizeCjEventId (value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }

  const trimmedValue = value.trim()

  if (!trimmedValue || trimmedValue.length > CJ_EVENT_MAX_LENGTH) {
    return null
  }

  return trimmedValue
}

export function getCjEventIdFromSearch (search: string): string | null {
  const params = new URLSearchParams(search)

  for (const [key, value] of params.entries()) {
    if (key.toLowerCase() === CJ_EVENT_QUERY_PARAM) {
      return normalizeCjEventId(value)
    }
  }

  return null
}

export function getCjEventId (options?: GetCjEventIdOptions): string | null {
  const { getCookie } = useCookies()
  const cookieValue = normalizeCjEventId(getCookie(CJ_COOKIE_NAME))

  if (cookieValue) {
    return cookieValue
  }

  const search = options?.search ?? (typeof window !== 'undefined' ? window.location.search : '')

  return getCjEventIdFromSearch(search)
}

export function useCjAffiliate (): UseCjAffiliateResult {
  return {
    getCjEventId,
    getCjEventIdFromSearch,
  }
}
